export enum AanvraagGASteps {
  BasisGegevens = 0,
  TewBinnenOnderwijs,
  TewOpenbaarAmbt,
  PriveSector,
}
